import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class AuditService {
  getAll(params) {
    return axios
      .get(`${config["apiUrl"]}audits/query`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  getByPat(patId, params) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/audits`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }
}

export default new AuditService();

